import CarEntity from "../../../../../domain/entities/CarEntity";
import CarImplDto from "../../../../dto/impl/CarImplDto";
import HostApi from "../../../../settings/HostApi";

// El backend solo devuelve los favoritos cuyo vehículo sigue activo.
const GetFavoriteCarsApiImpl = async (): Promise<CarEntity[]> => {
    if (!HostApi.getToken()) return [];
    try {
        const response = await HostApi.get("/favorites/", true);
        return response.map((car: any) => CarImplDto.fromJson(car));
    } catch (error) {
        return [];
    }
};

export default GetFavoriteCarsApiImpl;
